import React from 'react'
import styled from 'styled-components'
import Header from '../../atoms/Header/Header'
import Text from '../../atoms/Text/Text'
import { useStaticRandom } from '../../../hooks/useStaticRandom'

const Style = styled.div`
  background: white;
  height: auto;
  background-position: center;
  background-size: cover;
  background-color: #d9d6ff;
  @media (min-width: 700px) {
    background-image: url(${(props) => props.background});
    height: 500px;
  }
  width: 100%;
  padding-top: 60px;

  & > div {
    padding: 30px 30px 60px 30px;
    background: white;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
`

const Testimonials = ({ data, background }) => {
  const staticRandom = useStaticRandom()
  const testimonial = data[Math.floor(staticRandom() * data.length)]
  return (
    <Style background={background}>
      <div>
        <Header
          style={{
            marginBottom: '40px',
            fontSize: '28px',
            color: '#162941'
          }}
          testimonial
          center
          as="h3"
          display={2}
        >
          Testimonial
        </Header>
        <Text
          style={{ marginBottom: '10px', fontSize: '18px' }}
          small
        >
          {testimonial.content}
        </Text>
        <Text
          bold
          small
        >
          {testimonial.name}
        </Text>
      </div>
    </Style>
  )
}

export default Testimonials
